import {environment} from '../../../environments/environment';

export enum StyleLogsEnum {
  SUCCESS = 'font-weight: bold; font-size: 12px; color: #20bf6b;',
  ERROR = 'font-weight: bold; font-size: 12px; color: #e74c3c;',
  WARNING = 'font-weight: bold; font-size: 12px; color: #e67e22;',
  HIGHLIGHT = 'font-weight: bold; font-size: 12px; color: #B53471; text-shadow: 1px 1px 5px #ED4C67; padding-bottom: 5px;'
}

export class Logger {

  static group(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      if (optionalParams.length > 0) {
        console.group(`%c ${message} `, StyleLogsEnum.SUCCESS);
        console.groupEnd();
      } else {
        console.log(message, ...optionalParams);
      }
    }
  }

  static log(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.log('%c ' + message, StyleLogsEnum.SUCCESS);
      console.log(...optionalParams);
    }
  }
}
